<template>
  <div id="map" class="map">
     <div class="mapFilters" role="group">
      <button class="btn backBtn" @click="$router.push({ path: '/' })"><i class="icon-left-open"></i></button>
      <button type="button" class="btn" v-bind:class="{ active: ui.currentView == 'wind' }" @click="setView('wind')">Wind</button>
      <button type="button" class="btn" v-bind:class="{ active: ui.currentView == 'rain' }" @click="setView('rain')">Rain</button>
      <button type="button" class="btn" v-bind:class="{ active: ui.currentView == 'waves' }" @click="setView('waves')">Waves</button>
      <button type="button" class="btn" v-bind:class="{ active: ui.currentView == 'cams' }" @click="setView('cams')">Cams</button>
    </div>
    
    <div class="meter windMeter" v-if="ui.currentView == 'wind'">
      <div v-if="!user || user.profile.unit_wind === 'km/h'">
        <span>Wind Speed</span>
        <span>km/h</span>
        <span>0</span>
        <span>20</span>
        <span>40</span>
        <span>60</span>
        <span>80</span>
        <span>100</span>
      </div>
      <div v-else>
        <span>Wind Speed</span>
        <span>knots</span>
        <span>0</span>
        <span>12</span>
        <span>23</span>
        <span>35</span>
        <span>46</span>
        <span>58</span>
      </div>
    </div>
    <div class="meter rainMeter" v-if="ui.currentView == 'rain'">
      <span>Rain</span>
      <span>mm/3hr</span>
      <span>0</span>
      <span>6</span>
      <span>12</span>
      <span>18</span>
      <span>24</span>
      <span>30</span>
    </div>
    <div class="meter waveMeter" v-if="ui.currentView == 'waves'">
      <span>Wave Height</span>
      <span>m</span>
      <span>0</span>
      <span>2</span>
      <span>4</span>
      <span>6</span>
      <span>8</span>
      <span>10</span>
    </div>
    
    <l-map
      :zoom="zoom"
      :minZoom="3"
      :center="center"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate">
      <l-tile-layer
        :url="url"
        :attribution="attribution"/>
      <l-idw-layer
        v-if="ui.currentView == 'rain'"
        :geojson="rainfall.data"
        :options="rainfall.options"/>
      <l-vector-layer
        v-if="ui.currentView == 'wind'"
        :geojson="wind.data"
        :options="wind.options"/>
      <l-wave-layer
        v-if="ui.currentView == 'waves'"
        :geojson="wave.data"
        :options="wave.options"/>
      <l-marker v-if="ui.currentView == 'cams'" :icon="camicon" v-bind:key="cam.name" v-for="cam in cams" :lat-lng="[cam.latitude, cam.longitude]" @click="clickCamera(cam)"></l-marker>
      <l-marker v-if="userpin.lat" :icon="usericon" :lat-lng="[userpin.lat, userpin.long]"></l-marker>

    </l-map>
    
    <div class="legend">
      <span></span>
    </div>
    
    <!--CAMS VIEW-->
    <transition name="slide" mode="out-in">
        <cams-view v-if="ui.currentView == 'cams' && selectedCamera" :selectedCam='selectedCamera' :changeCam='clickCamera'></cams-view>
    </transition>
    <!--RANGE SCRUBBER-->
    <div class="rangeScrubber" v-bind:class="{loading: rainfall.loading}" v-if="ui.currentView == 'rain'|| ui.currentView == 'wind' || ui.currentView == 'waves'">
      <div class="dateRange">
        <span v-if="!rainfall.loading">{{currentTimeStamp}}</span>
        <span v-if="rainfall.loading">Loading...</span>
      </div>
      <input v-model="timeline.currentDate" type="range" v-bind:min="timeline.startDate" v-bind:max="timeline.endDate" step="10800">
        <a @click="toggleTimelineContinuous">
            <i v-if="!timeline.continuous" class="icon-right-open-big"></i>
            <i v-if="timeline.continuous" class="pauseIcon">||</i>
        </a>
      
    </div>
    
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import LIwdLayer from '../components/map/LIdwLeaflet'
import LWaveLeaflet from '../components/map/LWaveLeaflet'
import LVectorLeaflet from '../components/map/LVectorLeaflet'
import L from 'leaflet'
import CamsView from '../components/map/CamsView'
import moment from 'moment'
import axios from 'axios'
import { setTimeout } from 'timers'
import { mapState } from 'vuex'

let thiscamicon = new L.Icon({
  iconRetinaUrl: require('../../static/img/maps/camera-icon.png'),
  iconUrl: require('../../static/img/maps/camera-icon.png'),
  // shadowUrl: require('../../node_modules/leaflet/dist/images/marker-shadow.png'),
  iconSize: [31, 26]
})

let usericon = new L.Icon({
  iconRetinaUrl: require('../../static/img/maps/user-icon.png'),
  iconUrl: require('../../static/img/maps/user-icon.png'),
  iconAnchor: [16, 31],
  iconSize: [31, 31]
})

export default {
  name: 'mainlayermap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    'l-idw-layer': LIwdLayer,
    'l-vector-layer': LVectorLeaflet,
    'l-wave-layer': LWaveLeaflet,
    CamsView
  },
  mounted: function () {
    // Find the timeline for the current map
    let m = moment()
    let roundDown = m.startOf('hour')
    const remainder = (roundDown.hour() % 3)
    const dateTime = roundDown.subtract(remainder, 'hours')
    this.timeline.currentDate = dateTime.unix()
    this.timeline.startDate = dateTime.subtract(1, 'days').unix()
    this.timeline.endDate = dateTime.add(4, 'days').unix()

    if (this.$route.params.section) {
      this.setView(this.$route.params.section)
    }

    navigator.geolocation.getCurrentPosition(this.buildUrl, this.geoError)
  },
  data () {
    return {
      zoom: 8,
      center: [-29.936914876574946, 31.070483922958378],
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 8,
      currentCenter: [-29.936914876574946, 31.070483922958378],
      baseUrl: 'https://www.ncei.noaa.gov/thredds/wms/gfs-003-files/201810/20181016/gfs_3_20181016_1200_384.grb2?',
      ui: {
        currentView: 'wind'
      },
      timeline: {
        startDate: null,
        currentDate: null,
        endDate: null,
        continuous: false
      },
      rainfall: {
        data: [],
        options: {
          opacity: 0.3, cellSize: 0.25, exp: 1, max: 30
        },
        loading: true
      },
      userpin: {
        lat: null,
        long: null
      },
      wind: {
        data: [],
        options: {
          minVelocity: 0, // used to align color scale
          maxVelocity: 30, // used to align color scale
          particleWidth: 1,
          velocityScale: 0.005 // modifier for particle animations, arbitrarily defaults to 0.005
        },
        loading: true
      },
      wave: {
        data: [],
        options: {
          minVelocity: 0, // used to align color scale
          maxVelocity: 30, // used to align color scale
          velocityScale: 0.01, // modifier for particle animations, arbitrarily defaults to 0.005,
          particleWidth: 10
        },
        loading: true
      },
      selectedCamera: {}
    }
  },
  computed: {
    currentTimeStamp: function () {
      return moment(this.timeline.currentDate, 'X').format('ddd hA')
    },
    cams: function () {
      return this.$store.state.cameras
    },
    camicon: function () {
      return thiscamicon
    },
    usericon: function () {
      return usericon
    },
    ...mapState({
      user: state => state.user
    })
  },
  watch: {
    'timeline.currentDate': function (newTime) {
      this.rainfall.loading = true
      axios.get('https://fews.dbnfews.com/storage/rain_assets/' + newTime + '.json').then((response) => {
        let builder = response.data
        let header = builder.header
        let λ0 = header.lo1
        let φ0 = header.la2 // the grid's origin (e.g., 0.0E, 90.0N)
        let Δλ = header.dx
        let Δφ = header.dy // distance between grid points (e.g., 2.5 deg lon, 2.5 deg lat)
        let ni = header.nx
        let nj = header.ny // number of grid points W-E and N-S (e.g., 144 x 73)
        let date = new Date(header.refTime)
        date.setHours(date.getHours() + header.forecastTime)

        // Scan mode 0 assumed. Longitude increases from λ0, and latitude decreases from φ0.
        // http://www.nco.ncep.noaa.gov/pmb/docs/grib2/grib2_table3-4.shtml
        let p = 0
        let points = []
        for (let j = 0; j < nj; j++) {
          let currentLat = φ0 + (Δφ * j)
          for (let i = 0; i < ni; i++, p++) {
            if (builder.data[p]) {
              let currentLong = λ0 + Δλ * i
              let point = [currentLat, currentLong, builder.data[p]]
              points.push(point)
            }
          }
        }
        this.rainfall.data = points
        this.rainfall.loading = false
      })

      axios.get('https://fews.dbnfews.com/storage/wind_assets/' + newTime + '.json').then((response) => {
        this.wind.data = response.data
        this.wind.loading = false
      })

      axios.get('https://fews.dbnfews.com/storage/wave_assets/' + newTime + '.json').then((response) => {
        this.wave.data = response.data
        this.wave.loading = false
      })
    },
    'timeline.continuous': function (live) {
      if (live === true) {
        this.tickTimeInterval()
      }
    }
  },
  methods: {
    zoomUpdate (zoom) {
      this.currentZoom = zoom
      this.zoom = zoom
    },
    centerUpdate (center) {
      this.center = center
    },
    setView (view) {
      this.ui.currentView = view
    },
    clickCamera (cam) {
      this.selectedCamera = cam
    },
    tickTimeInterval () {
      setTimeout(() => {
        if (this.timeline.continuous === true) {
          console.log(this.timeline.currentDate)
          this.timeline.currentDate = parseInt(this.timeline.currentDate) + 10800
          // Only set another timeout if its under the max date
          if (this.timeline.currentDate <= this.timeline.endDate) {
            this.tickTimeInterval()
          }
        }
      }, 3000)
    },
    toggleTimelineContinuous () {
      this.timeline.continuous = !this.timeline.continuous
    },
    buildUrl (position) {
      this.userpin.lat = position.coords.latitude
      this.userpin.long = position.coords.longitude
    },
    geoError (error) {
      console.log(error)
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import "../../node_modules/leaflet/dist/leaflet.css";
  
  #map .rangeScrubber.loading a::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: 3px solid transparent;
    border-radius: 50%;
    border-top: 3px solid #fff;
    border-bottom: 3px solid #fff;
    animation: loadingAnimation 2s infinite linear;
  }
</style>



// WEBPACK FOOTER //
// src/views/Map.vue